<template>
    <el-drawer
        title="演出评论置顶"
        :visible="visible"
        class="form-drawer"
        :append-to-body="true"
        :wrapper-closable="false"
        size="600px"
        @open="getDetail"
        @close="close"
    >
        <div class="drawer-content">
            <el-form ref="formData" :model="formData" label-position="top">
                <el-form-item>
                    <template slot="label">评论所属演出ID</template>
                    <el-input
                        placeholder=""
                        disabled
                        v-model="detail.id">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <template slot="label">评论所属演出名称</template>
                    <el-input
                        placeholder=""
                        disabled
                        v-model="detail.mainName">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <template slot="label">评论所属巡演</template>
                    <el-input
                        placeholder=""
                        disabled
                        v-model="detail.tourName">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <template slot="label">当前演出置顶评论</template>
                    <el-input
                        placeholder=""
                        disabled
                        v-model="detail.content">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <template slot="label">当前巡演置顶评论</template>
                    <el-input
                        placeholder=""
                        disabled
                        v-model="detail.tourContent">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <template slot="label">置顶设置</template>
                    <el-checkbox-group v-model="formData.type">
                        <el-checkbox :label="1">演出</el-checkbox>
                        <el-checkbox :label="2">巡演</el-checkbox>
                    </el-checkbox-group>
                    <small class="MT10">
                        1、演出或巡演置顶评论最多只能有一条，将当前评论设为置顶后，会自动取消之前置顶的评论<br/>
                        2、评论列表会优先展示本站置顶的评论，如果本站无置顶评论，才会显示演出对应的巡演置顶评论
                    </small>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button :loading="saveLoading" type="primary" @click="save()">提交</el-button>
        </div>
    </el-drawer>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: [String, Number],
            default: ""
        },
        mainId: {
            type: [String, Number],
            default: ""
        }
    },
    data() {
        return {
            detail: {},
            formData: {
                type: []
            },
            saveLoading: false
        };
    },
    methods: {
        async getDetail () {
            if(!this.id) return;
            const response = await this.$request({
                url: "/letter/getTopSetData",
                method: "POST",
                data: {id: this.id, mainId: this.mainId},
            });
            const {state, msg, result} = response.data;
            if (state != 1) return this.$message.error(msg);
            this.detail = result;
            if(result.type === -1) this.formData.type = [1, 2];
            if(result.type === 1) this.formData.type = [1];
            if(result.type === 2) this.formData.type = [2];
        },
        async save () {
            this.saveLoading = true;
            let type = '';
            if(this.formData.type.length === 2) type = -1;
            if(this.formData.type.length === 1) type = this.formData.type[0];
            const response = await this.$request({
                url: "/letter/doTopSet",
                method: "POST",
                data: {id: this.id, type},
            });
            const {msg, state} = response.data;
            this.saveLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.$message.success('置顶设置成功');
            this.close();
            this.$emit('onRefresh', true);
        },
        close () {
            this.formData.type = [];
            this.$emit('update:visible', false);
        }
    },
};
</script>
